/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

export const FlagsPermissionOutgoingShipmentSTISC = {
  permission_sti_sc_enable: new FcsFlag.Flag(false),
  permission_sti_sc_create: new FcsFlag.Flag(false),
  reverse_scan_sti_sc_enable: new FcsFlag.Flag(true)
};

export function initFlagsPermissionOutgoingShipmentSTISC() {
  // register flags with namespaces for better grouping
  FcsFlag.register(
    "featureOutgoingShipmentSTISC",
    FlagsPermissionOutgoingShipmentSTISC
  );
}
